<app-system-message></app-system-message>
<meta charset="UTF-8" />
<!-- Container -->
<div [ngClass]="[theme.getThemeClass(), showFilterModal ? 'grayed-out' : '']" class="container-fluid">
  @if (loading) {
  <app-loading-element
    class="loadingElementContainer componentBelow"
  ></app-loading-element>
  } @if (dataLoaded) {
  <header class="mobileAlign2">
    <!-- Default header -->
    @if (!showDevicesMap) {
    <h2 class="mobile">
      {{ "ClientListThings" | translate }} ({{ filteredArray.length }})
    </h2>
    }
    <!-- Header for the device map-->
    @if (showDevicesMap) {
    <h2 class="mobile">
      {{ "ClientListThings" | translate }} ({{ devicesLocationArray.length }})
    </h2>
    }
  </header>
  }
  <!-- Search Bar for devices list -->
  @if (!showDevicesMap) {
  <div class="page-header">
    @if (dataLoaded) {
    <nav id="search-component" class="nav-sort-filter">
      <input
        #searchBox
        type="search"
        id="search-box"
        [(ngModel)]="userSearchInput"
        (input)="searchDevices()"
        class="form-control rounded searchInput"
        placeholder="{{ 'search' | translate }}"
        aria-label="Search"
        aria-describedby="search-addon"
      />
      <button
        [ngClass]="theme.getThemeClass()"
        class="btn bg-light text-dark filter-margin"
        (click)="toggleFilterModal()"
      >
        {{ "filter" | translate }}
      </button>

      <div class="card-title status">
        <div class="fa-2x sort-icon-div">
          <!-- <div class="mobileAlign"> -->
          <!-- Sort by name -->
          <a
            title="{{ 'alphabeticalOrder' | translate }}"
            (click)="sortBy('thingName')"
          >
            <div style="display: contents" [hidden]="!thingNameAsc">
              <i class="sort-icon fa-solid fa-sort-alpha-down"></i>
            </div>
            <div style="display: contents" [hidden]="thingNameAsc">
              <i class="sort-icon fa-solid fa-sort-alpha-down-alt"></i>
            </div>
          </a>
          <a title="{{ 'deviceBeat' | translate }}" (click)="sortBy('beat')">
            <i
              id="beatSort"
              class="sort-icon fa-solid fa-broadcast-tower grayC"
            ></i>
          </a>
          <!-- Sort by health -->
          <a
            title="{{ 'deviceHealth' | translate }}"
            (click)="sortBy('health')"
          >
            <i
              id="healthSort"
              class="sort-icon fa-solid fa-heart-pulse grayC"
            ></i>
          </a>
          <!-- Sort by battery -->
          <a
            title="{{ 'batteryLevel' | translate }}"
            (click)="sortBy('battery')"
          >
            <i
              id="batterySort"
              class="sort-icon fa-solid fa-battery-full grayC"
            ></i>
          </a>
          <!-- Sort by fill level -->
          <a
            title="{{ 'binFillLevel' | translate }}"
            (click)="sortBy('fillLevel')"
          >
            <i
              id="fillLevelSort"
              class="sort-icon fa-solid fa-trash-can grayC"
            ></i>
          </a>
        </div>
      </div>
    </nav>
    }
  </div>
  }
  <!-- Search Bar for devices map -->
  @if (showDevicesMap) {
  <div class="page-header">
    @if (dataLoaded) {
    <nav id="search-component" class="nav-sort-filter">
      <input
        #searchBox
        type="search"
        id="search-box"
        [(ngModel)]="userSearchInput"
        (input)="searchDevices()"
        class="form-control rounded searchInput"
        placeholder="{{ 'userlistSearchInputPlaceHolder' | translate }}"
        aria-label="Search"
        aria-describedby="search-addon"
      />
      <!-- [placeholder]="'subGroupCreateGroupName' | translate" -->
       <div class="select-wrapper">
         <select
           class="form-control ng-select sort-by-select"
           name="sub-group select"
           [(ngModel)]="subGroupFilter"
           (ngModelChange)="searchDevices()"
         >
          <option [ngValue]="null" disabled selected>{{ "selectSubGroup" | translate }}</option>
         @for(option of clientSubGroups; track option.sub_groupID){
           <option [ngValue]="option.sub_groupID">
             {{ option.sub_group_name}}
           </option>
         }
         </select>
         @if(subGroupFilter){
           <button
             type="button"
             class="clear-btn"
             (click)="clearSubGroup()"
             aria-label="Clear selection"
           >
             ×
           </button>
         }
       </div>
    </nav>
    }
  </div>
  } @if (dataLoaded) {
  <nav id="search-component" class="nav-sort-filter">
    @if (showDevicesMap === false) {
    <button
      [ngClass]="theme.getThemeClass()"
      class="btn bg-light text-dark"
      (click)="showReportModal()"
    >
      <span>
        {{ "reportModal" | translate }}
      </span>
    </button>
    }
    <button [ngClass]="theme.getThemeClass()" class="btn bg-light text-dark">
      <span>
        <a
          class="newSubGroup"
          [routerLink]="['/device-sub-group/create', clientID]"
          >{{ "newSubGroup" | translate }}</a
        >
      </span>
    </button>
    <button [ngClass]="theme.getThemeClass()" class="btn bg-light text-dark">
      <span>
        <a
          class="newSubGroup"
          [routerLink]="['/device-sub-group/view', clientID]"
          >{{ "alterSubGroup" | translate }}</a
        >
      </span>
    </button>

    @if (showDevicesMap === false) {
    <button
      [ngClass]="theme.getThemeClass()"
      class="btn bg-light text-dark"
      (click)="displayMapComponent(true)"
    >
      <span>
        {{ "iotModalViewDeviceLocation" | translate }}
      </span>
    </button>
    } @if (showDevicesMap === true) {
    <button
      [ngClass]="theme.getThemeClass()"
      class="btn bg-light text-dark"
      (click)="displayMapComponent(false)"
    >
      <span>
        {{ "userlistTableHeaderDeviceList" | translate }}
      </span>
    </button>
    }
  </nav>
  }
  <!-- Gridster Parent Container -->
  @if (dataLoaded) {
  <section
    [hidden]="showDevicesMap"
    class="gridThing"
    [ngClass]="[theme.getThemeClass()]"
  >
    <!-- Navigation Items -->
    @for (thing of filteredArray; track thing.thing_name; let i = $index) {
    <!-- Tile -->
    <article class="gridsterItemClientThing">
      <!-- Your tile content goes here -->
      <nav [ngClass]="theme.getThemeClass()" class="dashboardThing-tile">
        <header class="dashboard-tile-header">
          <!-- Light for device state -->
          <div
            class="mouseover-div"
            (mouseenter)="showStateInfo[i] = true"
            (mouseleave)="showStateInfo[i] = false"
            (touchstart)="showStateInfo[i] = true"
            (touchend)="showStateInfo[i] = false"
          >
            <div class="trafic-light-box">
              <div class="traffic-light">
                <div
                  class="light"
                  [ngClass]="{
                    'light-green':
                      thing.heartbeat && thing.heartbeat.color === 'green',
                    'light-yellow':
                      thing.heartbeat && thing.heartbeat.color === 'yellow',
                    'light-red':
                      thing.heartbeat && thing.heartbeat.color === 'red'
                  }"
                ></div>
              </div>
            </div>
            <h6 class="dashboardThing-tile-title">
              {{ thing.thing_name | translate }}
            </h6>
            <!-- Info bubble on mouse over -->
            @if (showStateInfo[i]) {
            <div class="info-state-box" [ngClass]="theme.getThemeClass()">
              <div class="state-info-layer">
                <label class="state-title">
                  {{ "beatMiss" | translate }} :
                </label>
                <label class="state-info">
                  @if ( iotService.isBeatMissMoreThenOneHundred(
                  thing.heartbeat?.beat_miss) ) {
                  <span>+</span>
                  }
                  {{ thing.heartbeat?.beat_miss || 0 }}
                </label>
              </div>
              <div class="state-info-layer">
                <label class="state-title">
                  {{ "suposeToCommunicate" | translate }} :
                </label>
                <label class="state-info">
                  {{ thing.heartbeat?.supposed_to_communicate || "" }}
                </label>
              </div>
              <div class="state-info-layer">
                <label class="state-title">
                  {{ "sleepTimeConfig" | translate }} :
                </label>
                <label class="state-info">
                  {{
                    iotService.convertSecondToHour(thing.sleep_time) | translate
                  }}
                </label>
              </div>
            </div>
            }
          </div>
          <span class="dashboard-tile-action-container">
            <a
              class="nav-link e"
              href="javascript:void(0);"
              data-bs-toggle="dropdown"
            >
              <i class="fa fa-bars"></i>
            </a>
            <ul
              [ngClass]="theme.getThemeClass()"
              class="dropdown-menu dropdown-menu-lg-end"
            >
              <!-- Menu Items -->
              <li>
                <a
                  [ngClass]="theme.getThemeClass()"
                  class="dropdown-item"
                  style="cursor: pointer"
                  (click)="setNavToDeviceStat(thing.thing_name)"
                >
                  <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                  <span class="customMarginLeft1">
                    {{ "deviceStatistics" | translate }}
                  </span>
                </a>
              </li>
              <li [ngClass]="{ closed: thing.bin_id === '' }">
                <a
                  (click)="routeToUpdateBin(thing.bin_id)"
                  [ngClass]="theme.getThemeClass()"
                  class="dropdown-item"
                  href="javascript:void(0)"
                >
                  <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                  <span
                    class="customMarginLeft1"
                    [ngClass]="{ closed: thing.bin_id === '' }"
                  >
                    {{ "viewBin" | translate }}
                  </span>
                </a>
              </li>
              <li>
                <a
                  (click)="exportCSV(thing)"
                  [ngClass]="theme.getThemeClass()"
                  class="dropdown-item"
                  href="javascript:void(0)"
                >
                  <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                  <span class="customMarginLeft1">
                    {{ "exportCSV" | translate }}
                  </span>
                </a>
              </li>
              <li>
                <a
                  (click)="iotService.showConfig(thing.thing_name)"
                  [ngClass]="theme.getThemeClass()"
                  class="dropdown-item"
                  href="javascript:void(0)"
                >
                  <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                  <span class="customMarginLeft1">
                    {{ "iotModalViewConfig" | translate }}
                  </span>
                </a>
              </li>
              <li>
                <a
                  (click)="toCreateWorkOrder(thing.thing_name)"
                  [ngClass]="theme.getThemeClass()"
                  class="dropdown-item"
                  href="javascript:void(0)"
                >
                  <i class="textAlignCenter" [ngClass]="thing.icon"></i>
                  <span class="customMarginLeft1">
                    {{ "createWorkOrder" | translate }}
                  </span>
                </a>
              </li>
            </ul>
          </span>
        </header>
        <div
          [ngClass]="theme.getThemeClass()"
          class="dashboardThing-tile-content"
        >
          <div class="marketLabel">
            {{ thing.device.bin.bin_usage | translate }}
            {{ thing.device.bin.market_segment | translate }}
          </div>

          <div class="itemsDisplay">
            <div class="firstRow">
              <!-- HEALTHY -->
              <div class="itemsColum">
                <div class="fa-3x">
                  @if (thing.status === 'Healthy') {
                  <i
                    class="fa-solid fa-heart-pulse greenC"
                    [title]="'Healthy' | translate"
                  ></i>
                  } @if (thing.status === 'Inactive') {
                  <i
                    class="fa-solid fa-heart-pulse grayC"
                    [title]="'Inactive' | translate"
                  ></i>
                  } @if (thing.status === undefined) {
                  <i
                    class="fa-solid fa-heart-pulse grayC"
                    [title]="'Inactive' | translate"
                  ></i>
                  } @if (thing.status === 'Unhealthy') {
                  <i
                    class="fa-solid fa-heart-pulse fa-fade redC"
                    [title]="'Unhealthy' | translate"
                  ></i>
                  }
                </div>
                <div class="iconLabel">
                  {{ thing.status | translate }}
                </div>
              </div>
              <!-- BATTERY -->
              <div class="itemsColum">
                <div class="fa-3x">
                  @if (thing.status === 'Inactive') {
                  <i
                    class="fa-solid fa-battery-empty grayC"
                    [title]="'Inactive'"
                  ></i>
                  } @if (thing.battery > 3.5 && thing.status != 'Inactive') {
                  <i
                    [ngStyle]="getBatteryLevel(thing.battery)"
                    class="fa-solid fa-battery-full"
                    [title]="thing.battery + '%'"
                  ></i>
                  } @if ( thing.battery <= 3.5 && thing.battery > 2.5 &&
                  thing.status != 'Inactive' ) {
                  <i
                    [ngStyle]="getBatteryLevel(thing.battery)"
                    class="fa-solid fa-battery-three-quarters"
                    [title]="thing.battery + '%'"
                  ></i>
                  } @if ( thing.battery <= 2.5 && thing.battery > 1.5 &&
                  thing.status != 'Inactive' ) {
                  <i
                    [ngStyle]="getBatteryLevel(thing.battery)"
                    class="fa-solid fa-battery-half"
                    [title]="thing.battery + 'V'"
                  ></i>
                  } @if ( thing.battery <= 1.5 && thing.battery > 0 &&
                  thing.status != 'Inactive' ) {
                  <i
                    [ngStyle]="getBatteryLevel(thing.battery)"
                    class="fa-solid fa-battery-quarter fa-fade"
                    [title]="thing.battery + '%'"
                  ></i>
                  } @if (thing.battery == 0 && thing.status != 'Inactive') {
                  <i
                    [ngStyle]="getBatteryLevel(thing.battery)"
                    class="fa-solid fa-battery-empty fa-fade"
                    [title]="thing.battery + '%'"
                  ></i>
                  } @if ( thing.battery == null || thing.battery == undefined )
                  {
                  <i
                    [ngStyle]="getBatteryLevel(thing.battery)"
                    class="fa-solid fa-battery-empty grayC"
                    [title]="'Inactive' | translate"
                  ></i>
                  }
                </div>
                @if ( thing.battery >= 0 && thing.battery <= 100 && thing.status
                != 'Inactive' ) {
                <div class="iconLabel">
                  {{ thing.battery + "%" | translate }}
                </div>
                } @if (thing.status === 'Inactive') {
                <div class="iconLabel">
                  {{ "Inactive" | translate }}
                </div>
                } @if (thing.battery > 100 && thing.status != 'Inactive') {
                <div class="iconLabel">
                  {{ "iotModalViewDeviceBatInCharge" | translate }}
                </div>
                }
              </div>
              <!-- FILL LEVEL -->
              <div class="itemsColum">
                <div class="fa-3x">
                  @if (thing.status === 'Healthy') {
                  <i
                    [ngStyle]="getFillLevelStyle(thing.fill_level)"
                    class="fa-solid fa-trash-can grayC"
                    [title]="thing.fill_level"
                  ></i>
                  } @if (thing.status === 'Unhealthy') {
                  <i
                    [ngStyle]="getFillLevelStyle(thing.fill_level)"
                    class="fa-solid fa-trash-can fa-fade grayC"
                    [title]="thing.fill_level"
                  ></i>
                  } @if ( thing.status === 'Inactive' || thing.status ===
                  undefined ) {
                  <i
                    class="fa-solid fa-trash-can grayC"
                    [title]="thing.fill_level"
                  ></i>
                  }
                </div>
                <div class="iconLabel">
                  {{ thing.fill_level | translate }}
                </div>
              </div>
              <!-- TONNAGE -->
              <div class="itemsColum">
                <div class="fa-3x">
                  <nav class="fadeIn first">
                    <img
                      style="height: 35px; width: 35px"
                      class="logo"
                      src="../assets/tonne-5123.webp"
                    />
                  </nav>
                </div>
                <div class="iconLabel">
                  {{ thing.tonnage + " T" }}
                </div>
              </div>
            </div>
            <div class="secondRow">
              <div class="locationLabel" [hidden]="!thing.hasBin">
                <i class="fa-solid fa-map-pin locationLabel"></i
                >{{ thing.location | translate }}
              </div>
              <div class="locationLabel" [hidden]="thing.hasBin">
                <i class="fa-solid fa-map-pin locationLabel"></i
                >{{ "withoutBin" | translate }}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </article>
    }
  </section>
  }

  

  <!-- Devices Location VIEW -->
  @if (showDevicesMap) {
    <app-devices-map [devices]="devicesLocationArray"></app-devices-map>
  }

  <app-report-modal
    class="appDeviceConfigModal"
    [hidden]="!reports.showReportModal"
  ></app-report-modal>
</div>

<!-- Graph Canvas for PDF Report -->
<div id="canvas-holder" class="canvasHolder">
  <canvas #tonnageCanvas class="displayNone"></canvas>
  <canvas #usageCanvas class="displayNone"></canvas>
  <canvas #marketCanvas class="displayNone"></canvas>
  <canvas #countCanvas class="displayNone"></canvas>
  <canvas #marketTonnageCanvas style="display: none"></canvas>
  <canvas #usageTonnageCanvas style="display: none"></canvas>
  <canvas #subgroupTonnageCanvas style="display: none"></canvas>
</div>

@if (iotService.showDeviceConfigModal) {
<app-device-modal-config class="appDeviceConfigModal"></app-device-modal-config>
}

<!-- Filter Modal -->
@if (showFilterModal) {
  <div [ngClass]="theme.getThemeClass()" class="filter-modal">
    <h2 class="filter-modal-header">Filter Devices</h2>
    <table>
      <!-- Sub-Groups -->
      <tr class="filter-modal-row">
        <td class="filter-modal-label">
          {{ "subGroupCreateGroupName" | translate }}:
        </td>
        <td class="select-wrapper">
          <select
            class="form-control ng-select sort-by-select"
            [(ngModel)]="subGroupFilter"
            [ngClass]="{ 'has-value': subGroupFilter }"
            (change)="searchDevices()"
          >
          @for(option of clientSubGroups; track option.sub_groupID){
            <option [ngValue]="option.sub_groupID">
              {{ option.sub_group_name}}
            </option>
          }
          </select>
          @if(subGroupFilter){
           <button
             type="button"
             class="clear-btn"
             (click)="clearSubGroup()"
             aria-label="Clear selection"
           >
             ×
           </button>
          }
        </td>
      </tr>
      <!-- Filter Device Health Status -->
      <tr class="filter-modal-row">
        <td class="filter-modal-label">
          {{ "deviceHealthStatus" | translate }}:
        </td>
        <td class="select-wrapper">
          <select
            [ngClass]="{ 'has-value': deviceHealthToBeFilterBy }"
            class="form-control ng-select sort-by-select"
            [(ngModel)]="deviceHealthToBeFilterBy"
            (change)="searchDevices()"
          >
          @for(option of deviceHealthOptions; track option.value){
            <option [ngValue]="option.value">
              {{ option.label | translate}}
            </option>
          }
          </select>
          @if(deviceHealthToBeFilterBy){
           <button
             type="button"
             class="clear-btn"
             (click)="clearHealthy()"
             aria-label="Clear selection"
           >
             ×
           </button>
          }
        </td>
      </tr>
      <!-- Filter by Bin Fill Level -->
      <tr class="filter-modal-row">
        <td class="filter-modal-label">{{ "binFillLevel" | translate }}:</td>
        <td class="select-wrapper">
          <select
            [ngClass]="{ 'has-value': binFillLevelToBeFilterBy }"
            class="form-control ng-select sort-by-select"
            [(ngModel)]="binFillLevelToBeFilterBy"
            (change)="searchDevices()"
          >
          @for(option of binFillLevelOptions; track option.value){
            <option [ngValue]="option.value">
              {{ option.label | translate}}
            </option>
          }
          </select>
          @if(binFillLevelToBeFilterBy){
           <button
             type="button"
             class="clear-btn"
             (click)="clearBinFill()"
             aria-label="Clear selection"
           >
             ×
           </button>
          }
        </td>
      </tr>
      <!-- Filter by Battery Level -->
      <tr class="filter-modal-row">
        <td class="filter-modal-label">{{ "batteryLevel" | translate }}:</td>
        <td class="select-wrapper">
          <select
            class="form-control ng-select sort-by-select"
            [(ngModel)]="batteryLevelToBeFilterBy"
            (change)="searchDevices()"
          >
          @for(option of batteryLevelOptions; track option.value){
            <option [ngValue]="option.value">
              {{ option.label | translate}}
            </option>
          }
          </select>
          @if(batteryLevelToBeFilterBy){
           <button
             type="button"
             class="clear-btn"
             (click)="clearBattery()"
             aria-label="Clear selection"
           >
             ×
           </button>
          }
        </td>
      </tr>
      <tr class="filter-modal-row">
        <td class="filter-modal-label">{{ "typeWaste" | translate }}:</td>
        <td class="select-wrapper">
          <select
            class="form-control ng-select sort-by-select"
            [(ngModel)]="wasteTypeToFilterBy"
            (change)="searchDevices()"
          >
          @for(option of binUsageType; track option.value){
            <option [ngValue]="option.value">
              {{option.label | translate}}
            </option>
          }
          </select>
          @if(wasteTypeToFilterBy){
           <button
             type="button"
             class="clear-btn"
             (click)="clearWasteType()"
             aria-label="Clear selection"
           >
             ×
           </button>
         }
        </td>
      </tr>
      <tr class="filter-modal-buttons">
        <td>
          <button
            [ngClass]="theme.getThemeClass()"
            class="btn bg-light text-dark"
            (click)="clearFilters()"
          >
            {{ "clearFilter" | translate }}
          </button>
        </td>
        <td>
          <button
            [ngClass]="theme.getThemeClass()"
            class="btn bg-light text-dark"
            (click)="toggleFilterModal()"
          >
            {{ "iotModalButtonClose" | translate }}
          </button>
        </td>
      </tr>
    </table>
  </div>
}
